module.exports = __webpack_public_path__ + "static/media/orange02.17994aa3.svg";